import { GetServerSidePropsContext } from 'next';
import { WishlistPage } from '@honeycomb/ui';
import { getPageAndGlobalProps } from '@honeycomb/data';

export default function Wishlist(): React.JSX.Element {
    return <WishlistPage />;
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
    return getPageAndGlobalProps(context);
};
